export default __webpack_public_path__ + "static/media/latvia.40315337.svg";